// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"047720d6","455":"ae4502be","623":"a83c7b90","791":"ebcad81a","801":"1ad21d61","977":"dd88ec79"}[chunkId] + ".chunk.js";
};